//import './box-selector.style.scss'
import clsx from 'clsx'
import { isDeviceMobile } from '@utils/mobile.ts'

type BoxComponentProps = {
	desktopTitle: string
	mobileTitle?: string
	icon: string
	action: () => void
}

const BoxComponent: React.FC<BoxComponentProps> = ({
	desktopTitle,
	mobileTitle,
	icon,
	action,
}) => (
	<div
		className={clsx('box__container', {
			'box__container--mobile': isDeviceMobile(),
		})}
		onClick={action}
	>
		<p className={'box__container--title'}>
			{mobileTitle && isDeviceMobile() ? mobileTitle : desktopTitle}
		</p>
		{!isDeviceMobile() && (
			<img
				className={'box__container--icon'}
				src={`/assets/images/${icon}`}
				alt={icon}
			/>
		)}
	</div>
)

type BoxSelectorComponentProps = {
	children: React.ReactNode
	desktopDescription: string
	mobileDescription?: string
	title?: string
	small?: boolean
	selected?: boolean
}
const BoxSelectorComponent: React.FC<BoxSelectorComponentProps> = ({
	children,
	desktopDescription,
	mobileDescription,
	small = false,
	selected = false,
	title,
}) => (
	<div
		className={clsx('box-selector', {
			'box-selector--small': small,
			'box-selector--selected': selected,
		})}
	>
		{title && <div className={'box-selector--title'}>{title}</div>}
		<div
			className={clsx('box-selector--description', {
				'box-selector--description-margin': !title,
			})}
		>
			<p>
				{mobileDescription && isDeviceMobile()
					? mobileDescription
					: desktopDescription}
			</p>
		</div>
		<div
			className={clsx('box-selector__container', {
				'box-selector__container--extra': title,
			})}
		>
			{children}
		</div>
	</div>
)

export { BoxSelectorComponent, type BoxComponentProps, BoxComponent }
